import { render, staticRenderFns } from "./MemberMenubar.vue?vue&type=template&id=328b7751&"
import script from "./MemberMenubar.vue?vue&type=script&lang=js&"
export * from "./MemberMenubar.vue?vue&type=script&lang=js&"
import style0 from "./MemberMenubar.vue?vue&type=style&index=0&id=328b7751&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
